import { Alert, Button, Input, Modal, Space, Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useState } from 'react';

const { Text } = Typography;

interface Props {
    apiKey: string;
    open: boolean;
    onClose: () => void;
}

export default function KeyRevealModal({ apiKey, open, onClose }: Props) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(apiKey);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Modal
            title="API Key Created"
            open={open}
            onOk={onClose}
            onCancel={onClose}
            okText="Done"
            cancelButtonProps={{ style: { display: 'none' } }}
        >
            <Alert
                type="warning"
                message="Save this key now. It won't be shown again."
                style={{ marginBottom: 16 }}
            />
            <Space.Compact style={{ width: '100%' }}>
                <Input
                    value={apiKey}
                    readOnly
                    style={{ fontFamily: 'monospace', fontSize: 13 }}
                />
                <Button
                    icon={<CopyOutlined />}
                    onClick={handleCopy}
                >
                    {copied ? 'Copied' : 'Copy'}
                </Button>
            </Space.Compact>
            <Text type="secondary" style={{ display: 'block', marginTop: 12, fontSize: 12 }}>
                Use this key in the <code>X-ModelPark-Key</code> header or as <code>Authorization: Bearer {'<key>'}</code>.
            </Text>
        </Modal>
    );
}
